import auth from '../auth';

import { useAuthSession } from './authSession';

const RouteAuth = ({ access, children }: { access: Array<string>; children: any }) => {
  const session = useAuthSession();
  if (!session.user) {
    auth.login();
    return <></>;
  }

  const isAuthorized = session.user.context?.roles.some((currentAccess) =>
    access.includes(currentAccess)
  );
  if (isAuthorized) {
    return children;
  }
  return (
    <div>
      <div>No autorizado</div>
    </div>
  );
};

export default RouteAuth;
